export default __webpack_public_path__ + "static/MY-LOGO-COLOUR-474610db381479c82553000d8d44470b.jpg";